import { userMetricsSagas } from './user/sagas'

export const metricsSagas = [...userMetricsSagas]
